import {REG} from "/@lib@/commons/registry.js";
import "/@back@/edit/wed/wedlets/box/boxLabelMulti.js";
import "/@back@/edit/wed/wedlets/box/boxLabelCounter.js";

/**
 * Stylage liés aux widgets assmnt
 * Permet de définir les styles transversaux à tous les binds.
 * A placer sur l'elt racine d'un du bind document et des binds racines des éditeurs en panels.
 * Les <wed:children/> de ce bind root doivent être placés dans un <box-host> pour bénéficier de stylage transversal.
 * Rappel : ces styles ne s'appliquent qu'aux balises racines des binds (pas celles qui entrent dans leurs shadowTree).
 */

/**
 * # assmntUnitMcq
 */


/**
 * Stylage des widgets structurés avec un head et un body.
 * Utilisé pour les blocs mais aussi les fields (inputs dans le wed:children de widget, et txt-root-inline dans ce widget)
 */

REG.reg.registerSkin('box/assmnt/mcq/choice', 1, /* language=CSS */ `
	.label {
		padding-inline-start: 20px;
		background-repeat: no-repeat;
		background-image: url('/@skin@/modeling/edit/wed/assmnt/mcq-m.svg');
	}

	:host(.scSingleUserResponse) .label {
		background-image: url('/@skin@/modeling/edit/wed/assmnt/mcq-s.svg');
	}

`);
